"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var icons_1 = require("../../../../icons");
var utils_1 = require("../../../../utils");
var ProgressBar_1 = __importDefault(require("../../../ProgressBar"));
var Text_1 = __importDefault(require("../../../Text"));
var FeaturedIcon_1 = __importDefault(require("../../../data-display/FeaturedIcon"));
var types_1 = require("../FileUploadItemList/types");
var CloseButton_1 = __importDefault(require("../../../buttons/CloseButton"));
var layout_1 = require("../../../layout");
var variables_1 = require("../../../../style/variables");
var documentFormats = ['csv', 'doc', 'docx', 'pdf', 'ppt', 'txt', 'xls', 'xlsx'];
var imageFormats = ['gif', 'jpg', 'jpeg', 'png'];
var mediaFormats = ['mp3', 'mp4'];
var getFileIcon = function (fileExtension) {
    // TODO: will have to get list of all file extensions for each type
    var Icon = icons_1.FileIcon; // TODO: change default icon
    if (documentFormats.includes(fileExtension)) {
        Icon = icons_1.FileDoc;
    }
    else if (imageFormats.includes(fileExtension)) {
        Icon = icons_1.Image;
    }
    else if (mediaFormats.includes(fileExtension)) {
        Icon = icons_1.Film;
    }
    return Icon;
};
var FileUploadIcon = function (_a) {
    var _b = _a.fileName, fileName = _b === void 0 ? '' : _b, status = _a.status;
    var fileExtension = utils_1.getFileExtension(fileName);
    var fileIcon = getFileIcon(fileExtension);
    var color = status === types_1.EXPORT_STATUS.ERROR ? 'Error' : 'Primary';
    return (react_1.jsx(FeaturedIcon_1.default, { color: color, icon: fileIcon, size: "sm", theme: "light-circle-outline" }));
};
var styles = {
    container: react_1.css({
        position: 'relative',
        padding: 16,
        border: "1px solid var(" + variables_1.RootColor.Gray.LIGHT_2 + ")",
        borderRadius: "var(" + variables_1.BorderRadius.sm + ")",
        backgroundColor: "var(" + variables_1.RootColor.White + ")",
    }),
    doneContainer: react_1.css({
        borderColor: "var(" + variables_1.ThemeColor.Primary.DEFAULT + ")",
    }),
    errorContainer: react_1.css({
        borderColor: "var(" + variables_1.ThemeColor.Error.LIGHT_1 + ")",
        backgroundClip: "var(" + variables_1.ThemeColor.Error.LIGHT_6 + ")",
    }),
    closeButton: react_1.css({
        position: 'absolute',
        top: 6,
        right: 6,
    }),
    text: react_1.css({
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
    }),
};
var FileUploadListItem = function (_a) {
    var item = _a.item, showFileIcon = _a.showFileIcon, onRemove = _a.onRemove, onRetry = _a.onRetry, disabled = _a.disabled;
    var hasError = item.uploadStatus.status === types_1.EXPORT_STATUS.ERROR;
    var canRetry = item.uploadStatus.status === types_1.EXPORT_STATUS.ERROR && item.uploadStatus.canRetry;
    var isDone = item.uploadStatus.status === types_1.EXPORT_STATUS.DONE;
    var handleClose = function (e) {
        e.stopPropagation();
        e.preventDefault();
        onRemove();
    };
    return (react_1.jsx(layout_1.Flex, { gap: 16, css: [
            styles.container,
            hasError ? styles.errorContainer : undefined,
            isDone ? styles.doneContainer : undefined,
        ] },
        showFileIcon ? (react_1.jsx(FileUploadIcon, { fileName: item.file.name, status: item.uploadStatus.status })) : null,
        react_1.jsx(layout_1.Flex, { direction: "column", gap: 4, css: { flex: 1, overflow: 'hidden' } },
            react_1.jsx(layout_1.Flex, { direction: "column", css: { flex: 1, overflow: 'hidden', marginRight: 16 } },
                react_1.jsx(Text_1.default.Body, { weight: "semibold", color: "var(" + (hasError ? variables_1.ThemeColor.Error.DARK_2 : variables_1.TextColor.HEAD) + ")", css: styles.text }, item.file.name),
                react_1.jsx(Text_1.default.Body, { color: "var(" + (hasError ? variables_1.ThemeColor.Error.DARK_1 : variables_1.TextColor.DEFAULT) + ")", css: styles.text }, item.uploadStatus.status === types_1.EXPORT_STATUS.ERROR ? (item.uploadStatus.message) : utils_1.formatBytes(item.file.size))),
            item.uploadStatus.status === types_1.EXPORT_STATUS.IN_PROGRESS ? (react_1.jsx(ProgressBar_1.default, { width: "100%", progress: item.uploadStatus.progress, textPosition: "right" })) : null,
            canRetry ? (react_1.jsx(Text_1.default.Body, { size: "sm", color: "var(" + variables_1.ThemeColor.Error.DARK_2 + ")", css: { cursor: 'pointer' } },
                react_1.jsx("span", { onClick: onRetry }, "Try Again"))) : null),
        react_1.jsx(CloseButton_1.default, { size: "small", onClick: handleClose, css: styles.closeButton, disabled: disabled })));
};
exports.default = FileUploadListItem;
